import * as localStorage from './local-storage-service';

const SOURCE_KEY = 'registrationSource';
const CAMPAIGN_KEY = 'registrationCampaign';

/**
 * Remembers ?source= / ?campaign= from the landing URL so they survive
 * navigation until the adjuster registers. The API validates the values.
 */
export function captureFromUrl(search: string = window.location.search) {
  const params = new URLSearchParams(search);
  const source = params.get('source');
  const campaign = params.get('campaign');

  if (source) {
    localStorage.save(SOURCE_KEY, source.trim().toLowerCase());
    if (!campaign) {
      localStorage.remove(CAMPAIGN_KEY);
    }
  }
  if (campaign) {
    localStorage.save(CAMPAIGN_KEY, campaign.trim());
  }
}

export function get(): { registrationSource?: string; registrationCampaign?: string } {
  return {
    registrationSource: localStorage.get<string>(SOURCE_KEY),
    registrationCampaign: localStorage.get<string>(CAMPAIGN_KEY),
  };
}

export function clear() {
  localStorage.remove(SOURCE_KEY);
  localStorage.remove(CAMPAIGN_KEY);
}
